import { render, staticRenderFns } from "./follow-query-base.vue?vue&type=template&id=0b832cf8&scoped=true"
import script from "./follow-query-base.vue?vue&type=script&lang=ts"
export * from "./follow-query-base.vue?vue&type=script&lang=ts"
import style0 from "./follow-query-base.vue?vue&type=style&index=0&id=0b832cf8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b832cf8",
  null
  
)

export default component.exports